// const host = 'http://10.30.11.92:8848'
const version = '2.0.0'

const devServer = 'https://appdev.61draw.com';
const productServer = 'https://app.61draw.com';
const testServer='https://apptest.61draw.com';
const preprodServer = 'https://app-preprod.61draw.com'

//  教师端PC请求地址 backend域名
const tPcDev = 'http://appdev.61draw.com';
const tPcProduct = 'https://app.61draw.com';
const tPcTest = 'https://apptest.61draw.com';
const tPcPreprod = 'https://app-preprod.61draw.com';


//项目地址
const devSite = 'http://appdev.61draw.com/live-h5/#/'
const productSite = 'https://static2.61info.com/live-h5/#/'
const testSite = 'https://apptest.61draw.com/live-h5/#/'
const preprodSite = 'https://app-preprod.61draw.com/live-h5/#/'



//监控地址
const monitorDevServer = 'http://monitor.dev.61info.cn'
const monitorTestServer = 'https://monitor-test.61info.cn'
const monitorProductServer = 'https://monitor.61info.cn'
const monitorpreProdServer = 'https://monitor-preprod.61info.cn'

// mitoSDK上传地址
const mitoSDKDevServer = 'https://reporter-fat.61info.cn'
const mitoSDKTestServer =  'https://reporter-fat.61info.cn'
const mitoSDKPreProdServer =  'https://reporter-fat.61info.cn'
const mitoSDKProductServer =  'https://reporter.61info.cn'

//物流服务
const ssoDevServer = 'http://logistics-dev.61info.cn'
const ssoTestServer = 'https://logistics-test.61info.cn'
const ssoPreServer = 'https://logistics-preprod.61info.cn'
const ssoServer = 'https://logistics.61info.cn'

// live-app-new 项目地址
// 设置页面跳转时的请按照原生APP携带的参数 跳转携带过去；
const appNew = {
    localhost: 'localhost',
    development: 'http://appdev.61draw.com',
    test: 'https://apptest.61draw.com/61info-wap/#/',
    preprod: 'https://app-preprod.61draw.com/61info-wap/#/',
    production: 'https://static2.61info.com/61info-wap/#/'
}

// https://activity.61info.cn/audio/#/audio
// https://activity-preprod.61info.cn/audio/#/audio
// https://activity-test.61info.cn/audio/#/audio
// lucky-draw.61info.cn
const luckDraw = {
    development: '',
    production: 'https://activity.61info.cn/audio/#/',
    test: 'https://activity-test.61info.cn/audio/#/',
    preprod: 'https://activity-preprod.61info.cn/audio/#/'
}

// 咕比H5域名
const aiH5DevHost = 'https://ai-h5-dev.61info.cn'
const aiH5TestHost = 'https://ai-h5-test.61info.cn'
const aiH5PreHost = 'https://ai-h5-preprod.61info.cn'
const aiH5ProHost = 'https://ai-h5.61info.cn'


let host= ''
let site = ''
let teacherSite = ''
let monitorHost = ''
let teacherHost
let teacherPCHost = ''
let ssoHost = ''
let aiH5Host = ''
// 环境常量-mito上传的host地址
let FE_MITO_DSN = ''

console.log('mode', process.env.REACT_APP_MODE)
if(process.env.REACT_APP_MODE === 'development') {
    host = devServer
    //host = 'http://10.30.11.137:8889'//庄迪电脑
    site = devSite
    teacherSite = devSite
    monitorHost = monitorDevServer
    teacherHost = 'http://gw-mg-dev.61info.cn/teacher-app-api/p'
    teacherPCHost = tPcDev
    ssoHost = ssoDevServer
    aiH5Host = aiH5DevHost
    FE_MITO_DSN = mitoSDKDevServer
}else if(process.env.REACT_APP_MODE === 'test'){
    host = testServer
    site = testSite
    monitorHost = monitorTestServer
    teacherSite = testSite
    teacherHost = 'https://gw-mg-test.61info.cn/teacher-app-api/p'
    // teacherHost = '//172.16.25.148:8896/p'
    teacherPCHost = tPcTest
    ssoHost = ssoTestServer
    aiH5Host = aiH5TestHost
    FE_MITO_DSN = mitoSDKTestServer
}else if(process.env.REACT_APP_MODE === 'production'){
    host = productServer
    site = productSite
    monitorHost = monitorProductServer
    teacherSite = 'https://static2.61info.com/live-h5/#/'
    teacherHost = 'https://gw-mg.61info.cn/teacher-app-api/p'
    teacherPCHost = tPcProduct
    ssoHost = ssoServer
    aiH5Host = aiH5ProHost
    FE_MITO_DSN = mitoSDKProductServer
}else if(process.env.REACT_APP_MODE === 'preprod'){
    host = preprodServer
    site = preprodSite
    teacherSite = preprodSite
    monitorHost = monitorpreProdServer
    teacherHost = 'https://gw-mg-preprod.61info.cn/teacher-app-api/p'
    teacherPCHost = tPcPreprod
    ssoHost = ssoPreServer
    aiH5Host = aiH5PreHost
    FE_MITO_DSN = mitoSDKPreProdServer
}
const COUSE_TYPE = {
    '1': '主修课', 
    '2': '衍生课', 
    '3': '体验课', 
    '4': '节假日衍生课', 
    '5': '系列衍生课'
}
const appNewHost = appNew[process.env.REACT_APP_MODE];
const luckDrawHost = luckDraw[process.env.REACT_APP_MODE];
export {
    host,
    site,
    COUSE_TYPE,
    teacherHost,
    teacherSite,
    monitorHost,
    teacherPCHost,
    ssoHost,
    version,
    luckDrawHost,
    appNewHost,
    aiH5Host,
    FE_MITO_DSN
}